import React from "react";
import { Upload } from "lucide-react";
import { useData } from "../context/DataContext";
import { exportToExcel } from "../utils/excel";

export default function SmsExportButton() {
  const { communications, properties } = useData();

  const doExport = () => {
    const sms = communications.filter((c) => c.type === "sms");
    const propMap = Object.fromEntries(properties.map((p) => [p.id, p.name]));
    const columns = [
      { header: "Tenant", value: (c) => c.tenantName },
      { header: "Phone", value: (c) => c.phone },
      { header: "Property", value: (c) => propMap[c.propertyId] || "" },
      { header: "House", value: (c) => c.houseNumber },
      { header: "Status", value: (c) => c.status },
      { header: "Message", value: (c) => c.message },
      { header: "Date", value: (c) => c.createdAt ? new Date(c.createdAt).toLocaleString("en-KE", { timeZone: "Africa/Nairobi" }) : "" },
      { header: "Automated", value: (c) => c.automated ? "Yes" : "No" },
    ];
    exportToExcel(sms, columns, "paysafi-sms-log.xlsx");
  };

  return (
    <button
      className="btn-secondary text-sm"
      onClick={doExport}
      disabled={communications.filter((c) => c.type === "sms").length === 0}
      aria-label="Export"
    >
      <Upload className="h-4 w-4" />
      <span className="hidden sm:inline">Export</span>
    </button>
  );
}
